<div class="oase-ansprechpartner">
  <mat-card appearance="outlined" *ngFor="let kategorie of kategorieListe" class="kontaktart_card" [ngClass]="{'warn-bg': kategorie.bezeichnung == 'Hofberater', 'hide':(kategorie.bezeichnung == 'Hofberater' && (lieferant && !lieferant.hatHofberater)) }">
    <mat-card-title>
      {{kategorie.bezeichnung}}
    </mat-card-title>
    <mat-card-content>
      <mat-list>
        <div *ngFor="let kontakt of kategorie.kontakte">
          <div *ngIf="kontakt.hofberater == null || (kontakt.hofberater != null && kontakt.isHofberater == true)">
            <div *ngIf="kategorie.bezeichnung == kontakt.kategorieBezeichnung" class="kontakt_item">
              <h4 mat-line class="kontakt_name">{{kontakt.nachname}} {{kontakt.vorname}} <span *ngIf="kontakt.funktion">({{kontakt.funktion}})</span></h4>
                <div mat-line *ngIf="kontakt.telefon" class="div_telefon"><a href="{{'tel:'+kontakt.telefon}}"><mat-icon mat-list-icon class="icon_info icon_telefon" >call</mat-icon><span class="icon_info_span info_span_telefon">{{kontakt.telefon}}</span></a></div>
                <div mat-line *ngIf="kontakt.email" class="div_email"><a href="{{'mailto:'+kontakt.email}}"><mat-icon mat-list-icon class="icon_info icon_email" >email</mat-icon><span class="icon_info_span info_span_email">{{kontakt.email}}</span></a></div>
                <div mat-line *ngIf="kontakt.fax" class="div_fax"><mat-icon mat-list-icon class="icon_info icon_fax" >print</mat-icon><span class="icon_info_span info_span_fax">{{kontakt.fax}}</span></div>
            </div>
          </div>
        </div>
      </mat-list>
    </mat-card-content>
  </mat-card>
</div>
